module.exports = __webpack_public_path__ + "img/star-slim.7185f203.svg";